// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedViewHandle_root__Gb-zZ","label":"TabbedViewHandle_label__2ICls","closeBtn":"TabbedViewHandle_closeBtn__1oGgb"};